import { type ReactNode } from 'react'
import { useRouter } from 'next/router'

import { ICON } from 'src/presentation/assets'
import S from './auth.module.scss'

interface AuthLayoutProps {
  children: ReactNode
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { pathname } = useRouter()

  const whatsappLink =
    pathname === '/formulario-seja-parceiro'
      ? 'https://wa.me/message/YLWCZYXJBBELF1'
      : 'https://api.whatsapp.com/send?phone=5519971385901&text=Ol%C3%A1!%20Vim%20do%20site%20da%20Am%C3%A9rica%20Financeira!'

  return (
    <div>
      <main>{children}</main>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className={S['whatsapp-button']}
      >
        <ICON.IconBrandWhatsapp className={S.icon} />
      </a>
    </div>
  )
}

export default AuthLayout

